import axios from 'axios'
import appConfig from 'configs/app.config'
import { TOKEN_TYPE, REQUEST_HEADER_AUTH_KEY } from 'constants/api.constant'
import { PERSIST_STORE_NAME } from 'constants/app.constant'
import deepParseJson from 'utils/deepParseJson'
import store from '../store'
import { onSignOutSuccess } from '../store/auth/sessionSlice'
import { objectToQueryString } from '../utils/objectToQueryString'

const unauthorizedCode = [401]

axios.defaults.paramsSerializer = (params) => {
  return objectToQueryString(params)
}

const BaseService = (params = {}) => {
  const axiosInstance = axios.create({
    timeout: 60000,
    baseURL: appConfig.apiPrefix,
  })
  axiosInstance.interceptors.request.use(
    (config) => {
      const rawPersistData = localStorage.getItem(PERSIST_STORE_NAME)
      const persistData = deepParseJson(rawPersistData)

      let accessToken = persistData.auth.session.token

      if (!accessToken) {
        const { auth } = store.getState()
        accessToken = auth.session.token
      }
      config.params = config.params || {}
      if (accessToken) {
        config.headers[REQUEST_HEADER_AUTH_KEY] = `${TOKEN_TYPE}${accessToken}`
        config.params.user =
          config.params.user ?? persistData.auth?.user?.userID
        config.params.userID = config.params.userID ?? config.params.user
        config.params.userId = config.params.userId ?? config.params.user
        config.params.licenseKey = accessToken
        config.params.license_key = config.params.licenseKey
        config.params.licenseKeyString = config.params.licenseKey
          
        if (config.data) {
          config.data = config.data || {}
          if (config.data && typeof config.data === 'object' && !Array.isArray(config.data)) {
            config.data = { 
              ...config.data, 
              user: config.data.user ?? persistData.auth?.user?.userID,
              userID: config.data.userID ?? config.data.user,
              userId: config.data.userId ?? config.data.user,
              licenseKey: accessToken,
              license_key: config.data.licenseKey,
              licenseKeyString: config.data.licenseKey,
              language: config.data.language || persistData.locale?.currentLang || 'en'
            }
          }
        }
      }
      config.params.language =
        config.params.language || persistData.locale?.currentLang || 'en'
      return config
    },
    (error) => {
      return Promise.reject(error)
    }
  )

  axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
      const { response } = error

      if (response && unauthorizedCode.includes(response.status)) {
        store.dispatch(onSignOutSuccess())
      }

      return Promise.reject(error)
    }
  )

  return axiosInstance(params)
}

export default BaseService
